<template>
  <v-container class="pa-0">
    <v-app-bar color="transparent" class="elevation-0 pa-0 page-header-toolbar">
      <page-header-title :title="page_title"></page-header-title>

      <v-spacer></v-spacer>

      <action-button type="back" @click="$router.go(-1)" />

      <action-button type="did_not_meet" @click="didNotMeet()" />

      <action-button type="check_in" @click="checkIn()" />
    </v-app-bar>

    <v-container grid-list-md class="pa-0">
      <v-layout row wrap>
        <v-flex xs12 md9>
          <v-form ref="form">
            <v-container grid-list-md>
              <v-card>
                <v-card-text class="pa-4">
                  <v-layout row wrap>
                    <v-flex md2 sm12 xs12 class="pr-4">
                      <v-img
                        :src="enrolment.image_url ? enrolment.image_url : require('@/assets/img/no-image.jpg')"
                        :height="$vuetify.breakpoint.smAndDown ? $vuetify.breakpoint.height / 2 : 'auto'"
                        contain
                      >
                        <v-menu offset-y>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn absolute fab bottom right small color="white" class="fab-update-image" v-bind="attrs" v-on="on">
                              <v-icon>camera_alt</v-icon>
                            </v-btn>
                          </template>
                          <v-list>
                            <v-list-item v-for="(item, index) in uploadSelections" :key="index">
                              <v-list-item-title @click="openUpload(item.key)">{{ item.label }}</v-list-item-title>
                            </v-list-item>
                          </v-list>
                        </v-menu>

                        <v-chip v-if="enrolment.cert_registry_user_id" small absolute top right class="mt-1 ml-1" color="primary">
                          {{ $t("checkin.certreg_id") + ": " + (enrolment.cert_registry_user_id ? enrolment.cert_registry_user_id : "") }}
                        </v-chip>
                      </v-img>
                    </v-flex>
                    <v-flex md10 sm12 xs12>
                      <v-layout row wrap>
                        <v-flex lg3 md4 sm6 xs12>
                          <v-text-field
                            name="first_name"
                            v-model="enrolment.first_name"
                            :label="$t('enrolments.p_first_name')"
                            class="required-field"
                            v-validate="'required|max:50'"
                            :error-messages="errors.collect('first_name')"
                            autocomplete="new-password"
                          ></v-text-field>
                        </v-flex>
                        <v-flex lg3 md4 sm6 xs12>
                          <v-text-field
                            name="last_name"
                            v-model="enrolment.last_name"
                            :label="$t('enrolments.p_last_name')"
                            class="required-field"
                            v-validate="'required|max:50'"
                            :error-messages="errors.collect('last_name')"
                            autocomplete="new-password"
                          ></v-text-field>
                        </v-flex>
                        <v-flex lg3 md4 sm6 xs12>
                          <v-text-field
                            name="email"
                            v-model="enrolment.email"
                            :label="$t('enrolments.p_email')"
                            class="required-field"
                            v-validate="'required|email|max:255'"
                            :error-messages="errors.collect('email')"
                            autocomplete="new-password"
                          ></v-text-field>
                        </v-flex>
                        <v-flex lg3 md4 sm6 xs12>
                          <v-text-field
                            name="mobile"
                            v-model="enrolment.mobile"
                            :label="$t('enrolments.p_mobile')"
                            class="required-field"
                            v-validate="'required|max:50|no_space'"
                            :error-messages="errors.collect('mobile')"
                            @blur="phoneNoSpace"
                            autocomplete="new-password"
                          ></v-text-field>
                        </v-flex>
                        <v-flex lg3 md4 sm6 xs12>
                          <v-dialog ref="dialog" v-model="dob_date_menu" persistent width="290px">
                            <template v-slot:activator="{ on }">
                              <v-text-field
                                name="date_of_birth"
                                v-model="computedDateofBirth"
                                :label="$t('enrolments.p_date_of_birth')"
                                class="required-field"
                                v-validate="'required|validDate'"
                                :error-messages="errors.collect('date_of_birth')"
                                append-icon="event"
                                @click:append="dob_date_menu = true"
                                :hint="'Format: ' + DATE_FORMAT"
                                autocomplete="new-password"
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              color="primary"
                              v-model="enrolment.date_of_birth"
                              first-day-of-week="1"
                              :locale="this.$locale_bcp47()"
                              :max="moment().subtract(1, 'days').format(MYSQL_DATE_FORMAT)"
                            >
                              <v-spacer></v-spacer>
                              <v-btn text color="primary" @click="dob_date_menu = false" class="darken-2">{{ $t("global.ok") }}</v-btn>
                            </v-date-picker>
                          </v-dialog>
                        </v-flex>
                        <v-flex lg3 md4 sm6 xs12>
                          <v-dialog ref="dialog" v-model="dob_employeed_from" persistent width="290px">
                            <template v-slot:activator="{ on }">
                              <v-text-field
                                name="employeed_from"
                                v-model="computedEmployeedFrom"
                                :label="$t('enrolments.employeed_from')"
                                v-validate="'validDate'"
                                :error-messages="errors.collect('employeed_from')"
                                append-icon="event"
                                @click:append="dob_employeed_from = true"
                                :hint="'Format: ' + DATE_FORMAT"
                                autocomplete="new-password"
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              color="primary"
                              v-model="enrolment.employeed_from"
                              first-day-of-week="1"
                              :locale="this.$locale_bcp47()"
                            >
                              <v-spacer></v-spacer>
                              <v-btn text color="primary" @click="dob_employeed_from = false" class="darken-2">{{ $t("global.ok") }}</v-btn>
                            </v-date-picker>
                          </v-dialog>
                        </v-flex>
                        <v-flex lg3 md4 sm6 xs12>
                          <v-select
                            name="o_name"
                            v-model="enrolment.enrolment_organisation_id"
                            item-text="name"
                            item-value="id"
                            :items="this.companies"
                            :label="$t('enrolments.o_name')"
                            :error-messages="errors.collect('o_name')"
                            clearable
                          ></v-select>
                        </v-flex>
                        <v-flex xs12>
                          <v-textarea
                            name="comments"
                            v-model="enrolment.comments"
                            rows="1"
                            auto-grow
                            :label="$t('enrolments.comment')"
                            :error-messages="errors.collect('comments')"
                          ></v-textarea>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-card>

              <v-card class="mt-2">
                <v-app-bar dense text color="secondary">
                  <v-toolbar-title class="subheading">{{ $t("enrolments.address_title") }}</v-toolbar-title>
                </v-app-bar>
                <v-card-text class="pa-4">
                  <v-layout row wrap>
                    <v-flex lg3 md4 sm6 xs12>
                      <v-text-field
                        name="enrolment.street"
                        v-model="enrolment.street"
                        v-validate="'max:50'"
                        :label="$t('enrolments.p_address_street')"
                        :error-messages="errors.collect('p_address_street')"
                        autocomplete="new-password"
                      ></v-text-field>
                    </v-flex>
                    <v-flex lg2 md4 sm6 xs12>
                      <v-text-field
                        name="enrolment.city"
                        v-model="enrolment.city"
                        v-validate="'max:50'"
                        :label="$t('enrolments.p_address_city')"
                        :error-messages="errors.collect('p_address_city')"
                        autocomplete="new-password"
                      ></v-text-field>
                    </v-flex>
                    <v-flex lg2 md4 sm6 xs12>
                      <v-text-field
                        name="enrolment.state"
                        v-model="enrolment.state"
                        v-validate="'max:50'"
                        :label="$t('enrolments.p_address_state')"
                        :error-messages="errors.collect('p_address_state')"
                        autocomplete="new-password"
                      ></v-text-field>
                    </v-flex>
                    <v-flex lg1 md4 sm6 xs12>
                      <v-text-field
                        name="enrolment.zip"
                        v-model="enrolment.zip"
                        v-validate="'max:6'"
                        :label="$t('enrolments.p_address_zip')"
                        :error-messages="errors.collect('p_address_zip')"
                        autocomplete="new-password"
                      ></v-text-field>
                    </v-flex>
                    <v-flex lg3 md4 sm6 xs12>
                      <v-autocomplete
                        name="enrolment.country"
                        v-model="enrolment.country"
                        :items="this.$dd_countries()"
                        item-text="text"
                        item-value="key"
                        :label="$t('enrolments.p_address_country')"
                        autocomplete="new-password"
                        :error-messages="errors.collect('p_address_country')"
                        clearable
                      ></v-autocomplete>
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-card>

              <v-dialog v-model="showUploadForm" persistent max-width="960px">
                <div class="form-modal pa-4">
                  <v-container class="pa-0">
                    <v-form ref="form">
                      <v-container grid-list-md>
                        <v-card>
                          <v-app-bar flat dense color="secondary">
                            <v-toolbar-title class="subheading">{{ $t("courses.upload_image") }}</v-toolbar-title>
                          </v-app-bar>

                          <v-card-text class="pa-4">
                            <ValidationObserver ref="upload_image">
                              <v-flex xs12>
                                <ValidationProvider :rules="'sizePerFileInMB:20'" v-slot="{ errors }">
                                  <v-file-input
                                    name="image"
                                    v-model="enrolment_image"
                                    accept=".jpg,.jpeg,.png"
                                    color="primary"
                                    counter
                                    :placeholder="$t('courses.select_image')"
                                    prepend-icon="attach_file"
                                    outlined
                                    :show-size="1000"
                                    @change="imageChange"
                                    clearable
                                    :error="errors.length > 0"
                                    :error-messages="errors[0]"
                                  >
                                    <template v-slot:selection="{ index, text }">
                                      <v-chip color="primary" dark label small>
                                        {{ text }}
                                      </v-chip>
                                    </template>
                                  </v-file-input>
                                </ValidationProvider>
                              </v-flex>
                            </ValidationObserver>
                            <v-flex xs12>
                              <v-card
                                @drop.prevent="documentOnDrop($event)"
                                @dragover.prevent="document_dragover = true"
                                @dragenter.prevent="document_dragover = true"
                                @dragleave.prevent="document_dragover = false"
                                :class="{ 'grey lighten-2': document_dragover }"
                              >
                                <v-card-text>
                                  <v-row class="d-flex flex-column" dense align="center" justify="center">
                                    <v-icon :class="[document_dragover ? 'mt-2, mb-6' : 'mt-5']" size="60"> mdi-cloud-upload </v-icon>
                                    <p>{{ $t("global.drop_files_here") }}</p>
                                  </v-row>
                                </v-card-text>
                              </v-card>
                            </v-flex>
                          </v-card-text>
                          <v-card-actions>
                            <v-spacer />

                            <action-button type="cancel" @click="cancelUpload" />
                            <action-button
                              type="crop"
                              @click="setupCropImage"
                              :text="$t('global.crop_and_upload')"
                              v-if="enrolment_image"
                            />
                            <!-- <action-button type="upload" @click="uploadImage()" v-if="enrolment_image" /> -->
                          </v-card-actions>
                        </v-card>
                      </v-container>
                    </v-form>
                  </v-container>
                </div>
              </v-dialog>

              <v-dialog v-model="showUploadCamera" persistent :max-width="$vuetify.breakpoint.height">
                <div class="form-modal pa-4">
                  <v-container class="pa-0">
                    <v-form ref="form">
                      <v-container grid-list-md>
                        <v-card>
                          <v-app-bar flat dense color="secondary">
                            <v-toolbar-title class="subheading">{{ $t("courses.upload_image") }}</v-toolbar-title>
                          </v-app-bar>

                          <v-card-text class="pa-2">
                            <v-flex xs12>
                              <vue-web-cam
                                ref="webcam"
                                :device-id="cameraDeviceId"
                                :resolution="{ width: 1920, height: 1080 }"
                                width="100%"
                                height="auto"
                                @cameras="cameraList"
                                @camera-change="cameraChange"
                              />
                            </v-flex>
                          </v-card-text>
                          <v-card-actions class="pt-0">
                            <v-spacer />

                            <action-button type="cancel" @click="cancelUploadCamera" />
                            <action-button type="switchcamera" :icon="'fas fa-sync'" @click="cameraSwitch" />
                            <action-button type="upload" :icon="'camera_alt'" @click="cameraCapture" :text="$t('global.capture')" />
                          </v-card-actions>
                        </v-card>
                      </v-container>
                    </v-form>
                  </v-container>
                </div>
              </v-dialog>

              <v-dialog v-model="showCropDialog" persistent :max-width="computedCropDialogWidth">
                <div class="form-modal pa-4">
                  <v-container class="pa-0">
                    <v-form ref="form">
                      <v-container grid-list-md>
                        <v-card>
                          <v-card-text>
                            <VueCropper
                              v-show="selectedCropImage"
                              ref="cropper"
                              :src="selectedCropImage"
                              alt="Source Image"
                              :aspect-ratio="7 / 9"
                              dragMode="move"
                              :toggleDragModeOnDblclick="false"
                            ></VueCropper>
                          </v-card-text>
                          <v-card-actions>
                            <action-button type="default" @click="$refs.cropper.rotate(90)" :icon="'rotate_right'" :icon_only="true" />
                            <action-button type="default" @click="$refs.cropper.rotate(-90)" :icon="'rotate_left'" :icon_only="true" />
                            <action-button type="default" @click="$refs.cropper.relativeZoom(0.1)" :icon="'zoom_in'" :icon_only="true" />
                            <action-button type="default" @click="$refs.cropper.relativeZoom(-0.1)" :icon="'zoom_out'" :icon_only="true" />
                            <v-spacer></v-spacer>
                            <action-button type="upload" @click="cropImage()" :icon_only="$vuetify.breakpoint.xsOnly" />
                            <action-button type="cancel" @click="cancelCropImage" :icon_only="$vuetify.breakpoint.xsOnly" />
                          </v-card-actions>
                        </v-card>
                      </v-container>
                    </v-form>
                  </v-container>
                </div>
              </v-dialog>
            </v-container>
          </v-form>
        </v-flex>
        <v-flex xs12 md3>
          <enrolmentDetails :id="Number(id)" />
        </v-flex>
      </v-layout>
    </v-container>

    <enrolmentVerifyPopup
      :key="reRenderEnrVerify"
      :id="enrVerifiySelectedId"
      @callback_enrverify_merge="callback_enrverify_merge"
      @callback_enrverify_cancel="callback_enrverify_cancel"
      @callback_enrverify_postprocess="callback_enrverify_postprocess"
    />
  </v-container>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate"
import enrolmentDetails from "../../enrolments/partials/EnrolmentDetails.vue"
import enrolmentVerifyPopup from "../../enrolments/partials/EnrolmentVerifyPopup.vue"
import VueCropper from "vue-cropperjs"
import "cropperjs/dist/cropper.css"
import { WebCam } from "vue-web-cam"

export default {
  name: "CheckinEnrol",

  props: ["cid", "id"],

  components: {
    ValidationObserver,
    ValidationProvider,
    enrolmentDetails,
    VueCropper,
    enrolmentVerifyPopup,
    "vue-web-cam": WebCam
  },

  data() {
    return {
      page_title: "",
      predata: {},
      enrolment: {},
      course: {},

      companies: [],

      showUploadForm: false,
      enrolment_image: null,
      document_dragover: false,

      showCropDialog: false,
      selectedCropImage: null,
      computedCropDialogWidth: 100,

      enrVerifiySelectedId: 0,
      reRenderEnrVerify: 0,

      dob_employeed_from: false,
      dob_date_menu: false,

      dictionary: {
        attributes: {
          first_name: this.$t("enrolments.p_first_name"),
          last_name: this.$t("enrolments.p_last_name"),
          email: this.$t("enrolments.p_email"),
          mobile: this.$t("enrolments.p_mobile"),
          date_of_birth: this.$t("enrolments.p_date_of_birth"),
          address_street: this.$t("enrolments.p_address_street"),
          address_city: this.$t("enrolments.p_address_city"),
          address_state: this.$t("enrolments.p_address_state"),
          address_zip: this.$t("enrolments.p_address_zip"),
          address_country: this.$t("enrolments.p_address_country"),
          employeed_from: this.$t("enrolments.employeed_from"),
          comments: this.$t("enrolments.comment")
        }
      },

      uploadSelections: [
        { key: "file", label: this.$t("global.from_file") },
        { key: "camera", label: this.$t("global.from_camera") }
      ],

      showUploadCamera: false,
      cameraImg: null,
      camera: null,
      cameraDeviceId: null,
      cameraDevices: []
    }
  },

  beforeRouteLeave(to, from, next) {
    this.$validator.validateAll().then(() => {
      this.$leaveFormConfirmation(next, this.enrolment, this.predata, this.save, this.isFormValid)
    })
  },

  mounted() {
    this.$validator.localize(this.$getSetting("locale"), this.dictionary)
  },

  created() {
    let lists = [{ key: "enrolled_organisations", module: "enrolled_organisations", query: "show_all=true" }]

    axios.post(this.API_URL + "request/ddlists", lists).then((res) => {
      this.companies = res.data.enrolled_organisations

      axios
        .get(this.API_URL + "enrolment/" + this.id)
        .then((res) => {
          this.enrolment = res.data.data
          this.course = this.enrolment.course
          this.page_title = this.$t("checkin.enrol_title", { name: this.enrolment.first_name + " " + this.enrolment.last_name })

          // JSON stringify and parse to remove variable reactiveness
          this.predata = JSON.parse(JSON.stringify(this.enrolment))
        })
        .catch((err) => console.log(err))
    })
  },

  watch: {
    camera: function (id) {
      this.deviceId = id
    }
  },

  computed: {
    cameraDevice: function () {
      return this.cameraDevices.find((n) => n.deviceId === this.cameraDeviceId)
    },
    isFormValid() {
      return !Object.keys(this.fields).some((key) => this.fields[key].invalid)
    },
    computedDateofBirth: {
      get() {
        return this.$dateFormatGetter(this.enrolment.date_of_birth)
      },
      set(val) {
        this.$set(this.enrolment, "date_of_birth", this.$dateFormatSetter(val))
      }
    },
    computedEmployeedFrom: {
      get() {
        return this.$dateFormatGetter(this.enrolment.employeed_from)
      },
      set(val) {
        this.$set(this.enrolment, "employeed_from", this.$dateFormatSetter(val))
      }
    }
  },

  methods: {
    imageChange(e) {
      if (!e) {
        this.enrolment.image_url = this.predata.image_url
      }
    },

    openUpload(action) {
      if (action == "camera") this.openUploadCamera()
      if (action == "file") this.openUploadForm()
    },

    openUploadCamera() {
      this.showUploadCamera = true
      this.cameraStart()
    },
    cancelUploadCamera() {
      this.showUploadCamera = false
      this.enrolment_image = null
      this.enrolment.image_url = this.predata.image_url
      this.cameraStop()
    },

    openUploadForm() {
      this.showUploadForm = true
    },

    cancelUpload() {
      this.showUploadForm = false
      this.enrolment_image = null
      this.enrolment.image_url = this.predata.image_url

      this.showCropDialog = false
      this.selectedCropImage = null
    },

    uploadImage() {
      let vm = this
      let formData = new FormData()

      if (this.enrolment_image) {
        formData.append("id", this.enrolment.id)
        formData.append("enrolment_image", this.enrolment_image)

        axios
          .post(this.API_URL + "enrolment/upload", formData, {
            headers: {
              "Content-Type": "multipart/form-data"
            }
          })
          .then((res) => {
            vm.enrolment = res.data.data
            vm.predata = JSON.parse(JSON.stringify(vm.enrolment))

            vm.$awn.success(vm.$t("global.update_success"))
            vm.cancelUpload()
            vm.cancelUploadCamera()
          })
          .catch((err) => console.log(err))
      }
    },

    async setupCropImage() {
      let vm = this

      if(this.$refs.upload_image) {
        const isValid = await this.$refs.upload_image.validate()
        if (!isValid) {
          return
        }
      }

      if (typeof FileReader === "function") {
        const reader = new FileReader()
        reader.onload = (event) => {
          vm.selectedCropImage = event.target.result

          let img = new Image()
          img.src = vm.selectedCropImage
          img.onload = () => {
            // compute for crop dialog width
            var window_width = vm.$vuetify.breakpoint.width
            var window_height = vm.$vuetify.breakpoint.height

            var img_width = img.naturalWidth
            var img_height = img.naturalHeight

            let obj = vm.$calculateAspectRatioFit(img_width, img_height, window_width, window_height)
            vm.computedCropDialogWidth = obj.width * 0.75 // 0.75 to decrease it by 25%

            vm.showCropDialog = true
            setTimeout(() => {
              vm.$refs.cropper.replace(vm.selectedCropImage)
            }, 200)
          }
        }
        reader.readAsDataURL(this.enrolment_image)
      } else {
        alert("Sorry, FileReader API not supported")
      }
    },
    cropImage() {
      var base64 = this.$refs.cropper.getCroppedCanvas().toDataURL()

      this.$refs.cropper.getCroppedCanvas().toBlob((blob) => {
        var file = new File([blob], this.enrolment_image.name, { type: this.enrolment_image.type })

        this.enrolment_image = file
        this.uploadImage()

        this.showCropDialog = false
        this.selectedCropImage = null
      }, this.enrolment_image.type)
    },
    cancelCropImage() {
      this.showCropDialog = false
    },
    documentOnDrop(e) {
      this.document_dragover = false
      let valid_ext = ["jpg", "jpeg", "png"]
      if (e.dataTransfer.files.length) {
        let file = e.dataTransfer.files[0] || null
        if (file) {
          let ext = file.name.split(".").pop()
          if (valid_ext.includes(ext)) {
            this.enrolment_image = file
          }
        }
      }
    },

    convert(id) {
      let vm = this

      axios
        .post(this.API_URL + "participant/convert", {
          id: id
        })
        .then((res) => {
          if (typeof res.data.errors !== "undefined") {
          } else {
            if (res.data.data.id) {
              this.predata = JSON.parse(JSON.stringify(this.enrolment))

              vm.markAttendanceFirstTime(res.data.data.id)
              vm.$awn.success(vm.$t("enrolments.add_to_participant_success"))
            } else {
              vm.$awn.alert(vm.$t("enrolments.add_to_participant_error"))
            }

            vm.$router.push(this.BACKEND_URL + "/checkin/" + this.cid)
          }
        })
        .catch((error) => {
          if (error.response.status == 451) {
            vm.$awn.alert(vm.$t("enrolments.already_enrolled"))
            vm.$router.push(this.BACKEND_URL + "/checkin/" + this.cid)
          }
        })
    },

    update(run) {
      this.$validator.validate()

      this.$validator
        .validateAll()
        .then(() => {
          if (this.isFormValid) {
            let vm = this

            axios
              .put(this.API_URL + "enrolment", {
                id: this.enrolment.id,
                course_id: this.cid,
                enrolment_organisation_id: this.enrolment.enrolment_organisation_id,
                first_name: this.enrolment.first_name,
                last_name: this.enrolment.last_name,
                email: this.enrolment.email,
                mobile: this.enrolment.mobile,
                date_of_birth: this.enrolment.date_of_birth,
                street: this.enrolment.street,
                city: this.enrolment.city,
                state: this.enrolment.state,
                zip: this.enrolment.zip,
                country: this.enrolment.country,
                employeed_from: this.enrolment.employeed_from,
                comments: this.enrolment.comments
              })
              .then((res) => {
                vm.enrolment = res.data.data
                vm.predata = JSON.parse(JSON.stringify(vm.enrolment))

                run()
              })
              .catch((err) => console.log(err))
          } else {
            this.$awn.alert(this.$t("global.form_not_valid"))
          }
        })
        .catch(() => {})
    },

    checkIn() {
      this.update(() => {
        this.$awn.confirm(
          this.$t("enrolments.convert_to_participant_message"),
          () => {
            this.callback_enrverify_show(Number(this.id))
          },
          () => {}
        )
      })
    },

    didNotMeet() {
      let vm = this

      this.update(() => {
        this.$awn.confirm(
          this.$t("checkin.did_not_meet_confirm"),
          () => {
            axios
              .post(this.API_URL + "enrolment/update-status", {
                id: this.id,
                status: 2
              })
              .then((res) => {
                vm.$router.push(this.BACKEND_URL + "/checkin/" + this.cid)
                vm.$awn.success(vm.$t("global.update_success"))
              })
              .catch((err) => console.log(err))
          },
          () => {
            return
          }
        )
      })
    },

    markAttendanceFirstTime(participant_id) {
      if (this.course.id && participant_id) {
        axios
          .get(this.API_URL + "attendees?show_all=true&query_course_id=" + this.course.id + "&query_participant_id=" + participant_id)
          .then((res) => {
            let data = []
            let attendees = res.data.data

            attendees.forEach((item, i) => {
              if (item.met_up_days.length > 0) {
                // Set the first checkbox for met_up_days to be checked
                let metupdays = item.met_up_days
                metupdays[0].value = true

                let obj = {}
                obj.id = item.id
                obj.met_up_days = metupdays
                obj.comment = item.comment

                data.push(obj)
              }
            })

            axios
              .put(this.API_URL + "course/attendance", {
                id: this.course.id,
                data: data
              })
              .then((res) => {})
              .catch((err) => console.log(err))
          })
          .catch((err) => console.log(err))
      }
    },
    phoneNoSpace() {
      if (this.enrolment.mobile) {
        this.enrolment.mobile = this.enrolment.mobile.replace(/\s/g, "")
        let field = this.errors.items.find((i) => i.field == "mobile" && i.rule == "no_space")
        if (field) this.$validator.errors.removeById(field.id)
      }
    },

    callback_enrverify_show(id) {
      this.enrVerifiySelectedId = id
      this.reRenderEnrVerify++
    },
    callback_enrverify_merge(bool) {
      if (bool) {
        this.enr_refresh = true
        this.attendee_refresh = true
      }
    },
    callback_enrverify_cancel() {
      this.enrVerifiySelectedId = 0
    },
    callback_enrverify_postprocess() {
      this.convert(this.enrVerifiySelectedId)
    },

    cameraCapture() {
      let capture = this.$refs.webcam.capture()
      if (capture) {
        var file = this.$dataURLtoFile(capture, "capture.jpg")
        this.enrolment_image = file
        this.setupCropImage()
      }
    },
    cameraStop() {
      if (this.$refs.webcam) {
        this.$refs.webcam.stop()
      }
    },
    cameraStart() {
      if (this.$refs.webcam) {
        this.$refs.webcam.start()
      }
    },
    cameraList(cameras) {
      this.cameraDevices = cameras

      const [first] = this.cameraDevices
      if (first) {
        this.camera = first.deviceId
        this.cameraDeviceId = first.deviceId
      }
    },
    cameraChange(deviceId) {
      this.cameraDeviceId = deviceId
      this.camera = deviceId
    },
    cameraSwitch() {
      let idx = this.cameraDevices.findIndex((x) => x.deviceId === this.cameraDeviceId)
      let devicesCount = this.cameraDevices.length

      if (devicesCount > 1) {
        idx = (idx + 1) % devicesCount
        let newCamera = this.cameraDevices[idx]
        if (newCamera) {
          this.cameraChange(newCamera.deviceId)
        }
      }
    }
  }
}
</script>

<style scoped>
.fab-update-image {
  bottom: 5px !important;
  right: 0px !important;
}
</style>
